import React from 'react';
import {connect} from 'react-redux';
import {push} from 'connected-react-router';

import {hasAccess} from '../../app/user';
import {isMobile} from '../../app/configuration/util';
import DesktopOnDemand from './DesktopOnDemand';
import MobileOnDemand from './MobileOnDemand';
import getSettings from './../../actions/customer';
import {get} from 'lodash';
import {
  searchVehicles,
  searchDVRs,
  loadChannels,
  loadQueueList,
  loadPreviouslyQueueList,
  clearChannels,
  clearTables,
  clearTablesList,
  loadTotalRequested,
  postFetchAsync,
  reset,
  scanVideoAvailable,
  goToLibrary,
  cancelOndemandMedia,
  changeWifiCheckbox,
  getDVRTotalByMachineType
} from '../OnDemandActions';
import {logout} from '../../app/user/UserActions';
import storeProvider from '../../store';
const store = storeProvider.getStore();
class OnDemand extends React.Component {
  componentDidMount() {
    const systemId = localStorage.getItem('systemId');
    if (systemId && systemId === 'geotab') {
      window.addEventListener('resize', this.dimensions);
      this.dimensions();
    }
    this.props.getDVRTotalByMachineType(4);
  } 
  dimensions = () => {
    const root = document.getElementById('root');
    if (root.offsetWidth <= 1100 && !root.classList.contains('small-screen-geotab-collapsed')) {
      root.classList.add('small-screen-geotab-collapsed');
      root.classList.remove('geotab-collapsed');
    } else if (root.offsetWidth > 1100 && root.classList.contains('small-screen-geotab-collapsed')) {
      root.classList.remove('small-screen-geotab-collapsed');
    }

    if (root.offsetWidth <= 1700 && root.offsetWidth > 1100 && !root.classList.contains('geotab-collapsed')) {
      root.classList.add('geotab-collapsed');
    } else if (root.offsetWidth > 1700 && root.classList.contains('geotab-collapsed')) {
      root.classList.remove('geotab-collapsed');
    }
  }
  render() {
    const props = {
      ...this.props,
      ...this.state
    };
    const system = get(store.getState(), 'system.settings', {});
    props.systemSettings = system;
    return props.isMobile ? <MobileOnDemand {...props} /> : <DesktopOnDemand {...props} />;
  }
}

function mapStateToProps(state) {
  const {onDemand, customer, user} = state;
  const isInternalUser = hasAccess(['videoIntelligenceInternal']);
  return {
    ...onDemand,
    ...state.i18n.locale,
    isInternalUser,
    customer,
    user,
    isMobile: isMobile(state)
  };
}

export default connect(mapStateToProps, {
  searchVehicles,
  searchDVRs,
  loadChannels,
  loadQueueList,
  loadPreviouslyQueueList,
  clearChannels,
  clearTables,
  clearTablesList,
  loadTotalRequested,
  postFetchAsync,
  logout,
  reset,
  push,
  scanVideoAvailable,
  goToLibrary,
  cancelOndemandMedia,
  changeWifiCheckbox,
  getSettings,
  getDVRTotalByMachineType
})(OnDemand);
